export default {
  default: {
    icon: 'fa fa-check'
  }
};